import React from "react";
import { t } from "i18next";
import { withTranslation } from "react-i18next";

import { SUBHEADING_FIELD } from "@constants/register";
import {
  OptionProps,
  SelectBoxFieldProps,
} from "@models/components/formElements.model";

const SelectBoxFieldComponent: React.FC<SelectBoxFieldProps> = ({
  className,
  disabled = false,
  errors,
  id,
  label,
  name,
  optionsData,
  register,
  registerOptions,
}) => {
  return (
    <>
      <select
        className={className}
        id={id}
        {...register(name, registerOptions[name])}
        data-testid="selectBox"
        disabled={disabled}
      >
        {optionsData.length > 0 &&
          optionsData.map((option: OptionProps, index: number) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
      <label htmlFor={name}>{label}*</label>
      {name === SUBHEADING_FIELD.LANGUAGE && (
        <div className="form-text p-0">{t("languageSubHeading")}</div>
      )}
      {name === SUBHEADING_FIELD.COUNTRY && (
        <div className="form-text p-0">{t("countrySubHeading")}</div>
      )}
      {errors[name] && (
        <div className="invalid-feedback">{errors[name].message}</div>
      )}
    </>
  );
};

const SelectBoxField = withTranslation()(SelectBoxFieldComponent);

export default SelectBoxField;
